<template>
<div>
    <base-header v-once pageName="상세검색" :popup="true"></base-header>
    <section id="wrap">
        <div class="detail-search">
            <base-selectbox selectName="고객유형"
                :default="defaultCustDiv" 
                :only="false"
                v-on:selectSearch="selectCustDiv"
                :options="custDivOption"
            ></base-selectbox>
            <dl>
                <dt>자녀나이</dt>
                <dd>
                    <base-selectbox selectName="자녀나이"
                        :default="defaultFromAge" 
                        :only="false"
                        v-on:selectSearch="selectFromAge"
                        :options="ageOption"
                    ></base-selectbox>
                    <i>~</i>
                    <base-selectbox selectName="자녀나이"
                        :default="defaultToAge" 
                        :only="false"
                        v-on:selectSearch="selectToAge"
                        :options="ageOption"
                    ></base-selectbox>
                </dd>
                <dt>진단서비스</dt>
                <dd>
                    <span class="checkbox">
                        <input type="checkbox" v-model="dgnsStatAll" @click="checkAllDgnsStat" id="gropu31-1">
                        <label for="gropu31-1">전체</label>
                    </span>
                    <span class="checkbox">
                        <input type="checkbox" v-model="dgnsStat2" @click="checkDgnsStat2" id="gropu31-2">
                        <label for="gropu31-2">진단</label>
                    </span>
                    <span class="checkbox">
                        <input type="checkbox" v-model="dgnsStat1" @click="checkDgnsStat1" id="gropu31-3">
                        <label for="gropu31-3">미진단</label>
                    </span>
                    <span class="checkbox">
                        <input type="checkbox" v-model="dgnsStat3" @click="checkDgnsStat3" id="gropu31-4">
                        <label for="gropu31-4">진단경과</label>
                    </span>
                </dd>
                <dd>
                    <span class="checkBtn">
                        <input type="checkbox" v-model="KEDS" id="gropu32-1">
                        <label for="gropu32-1">KED-S</label>
                    </span>
                    <span class="checkBtn">
                        <input type="checkbox" v-model="KEDI" id="gropu32-2">
                        <label for="gropu32-2">KED-I</label>
                    </span>
                    <span class="checkBtn">
                        <input type="checkbox" v-model="ELT" id="gropu32-3">
                        <label for="gropu32-3">AI ELT</label>
                    </span>
                </dd>
                <template v-if="'SCD02' != custDiv">
                    <dt>연체상태</dt>
                    <dd>
                        <span class="checkBtn">
                            <input type="checkbox" v-model="ovrdN" id="gropu4-1">
                            <label for="gropu4-1">미연체</label>
                        </span>
                        <span class="checkBtn">
                            <input type="checkbox" v-model="ovrdY" id="gropu4-2">
                            <label for="gropu4-2">연체</label>
                        </span>
                    </dd>
                    <dt>상품만료여부</dt>
                    <dd>
                        <base-selectbox selectName="상품만료여부"
                            :default="defaultExpyYn" 
                            :valName="''"
                            :only="false"
                            v-on:selectSearch="selectExpyYn"
                            :options="expyYnOption"
                        ></base-selectbox>
                    </dd>
                    <dt>상품검색 <span>(최대 5개 선택)</span></dt>
                    <dd>
                        <button type="button" class="prod-search" @click="popProdSearch">상품검색</button>
                    </dd>
                    <dd class="flex-left">
                        <template v-if="this.selectedProdList.length > 0">
                        <span class="radio">
                            <input type="radio" v-model="prodIncludeYn" value="Y" id="gropu5-1">
                            <label for="gropu5-1">선택 상품 포함</label>
                        </span>
                        <span class="radio">
                            <input type="radio" v-model="prodIncludeYn" value="N" id="gropu5-2">
                            <label for="gropu5-2">선택 상품 미포함</label>
                        </span>
                        <div class="result">
                            <button type="button" v-for="(prod, index) in selectedProdList" :key="index" @click="delPick(index)">{{prod.prdtnm}}</button>
                        </div>
                        </template>
                    </dd>
                </template>
            </dl>
        </div>
    </section>
    <div class="btnWrap">
        <button type="button" class="black" @click="init()">초기화</button>
        <button type="button" class="red" @click="searchDetail()">검색</button>
    </div>
  </div>
</template>

<script>
// import DatePick from 'vue-date-pick';
//var DatePick = () => import(/* webpackChunkName: "vue-date-time" */ 'vue-date-pick');

export default {
  name: "DetailSearch",
  components: {
    //DatePick
  },
  data() {
    return {
        defaultCustDiv: "전체",
        custDiv: "",
        custDivOption : [{text:'전체',value:'ALL'},{text:'계약',value:'SCD01'},{text:'가망',value:'SCD02'}],
        ageOption : [{text:'0',value:'0'},{text:'1',value:'1'},{text:'2',value:'2'},{text:'3',value:'3'},{text:'4',value:'4'},{text:'5',value:'5'}
                        ,{text:'6',value:'6'},{text:'7',value:'7'},{text:'8',value:'8'},{text:'9',value:'9'},{text:'10',value:'10'}
                        ,{text:'11',value:'11'},{text:'12',value:'12'},{text:'13',value:'13'},{text:'14',value:'14'},{text:'15',value:'15'},{text:'16',value:'16'}],
        defaultExpyYn: "전체",
        expyYnOption : [{text:'전체',value:''},{text:'만료예정',value:'A'},{text:'만료',value:'B'}],
        defaultFromAge: "선택해주세요",
        fromAge: "0",
        defaultToAge: "선택해주세요",
        toAge: "0",
        dgnsStatAll: false,
        dgnsStat1: false,
        dgnsStat2: false,
        dgnsStat3: false,
        KEDS: false,
        KEDI: false,
        ELT: false,
        ovrdY: false,
        ovrdN: false,
        concexpydyYn: "",
        prodIncludeYn: "",
        selectedProdList: [],
    };
  },
  watch: { // 팝업창에서 값 받는 부분.
    '$store.state.ui.child'(child) {
        if(child.name == 'cstmr-detail-search-selectedprodlist'){  // 상품검색 팝업에서 검색했을  때
            //console.log("DetailSearch.vue cstmr-detail-search-selectedprodlist data:",this.$store.state.ui.child.data);
            this.selectedProdList = this.$store.state.ui.child.data;
            
            //console.log("DetailSearch.vue cstmr-detail-search-selectedprodlist this.selectedProdList:",this.selectedProdList);
            if(this.selectedProdList && this.selectedProdList.length > 0){
                this.prodIncludeYn = "Y";
            }else{
                this.prodIncludeYn = "N";
            }
        }
        console.log("DetailSearch.vue this.selectedProdList:",this.selectedProdList);
    }
  },
  methods: {
    params() { // 상세 검색 조건 리턴. 날짜는 '-' 제거.
      return {
        custDiv: this.custDiv,
        fromAge: this.fromAge,
        toAge: this.toAge,
        dgnsStat1: this.dgnsStat1,
        dgnsStat2: this.dgnsStat2,
        dgnsStat3: this.dgnsStat3,
        KEDS: this.KEDS,
        KEDI: this.KEDI,
        ELT: this.ELT,
        ovrdY: this.ovrdY,
        ovrdN: this.ovrdN,
        concexpydyYn: this.concexpydyYn,
        prodIncludeYn: this.prodIncludeYn,
        selectedProdList: this.selectedProdList
      };
    },
    selectCustDiv: function(data){ // 고객유형 선택
        //console.log(data);
        if('ALL' != data){
            this.custDiv = data;
        }else{
            this.custDiv = '';
        }        
        if(this.custDiv){
            for(var h=0; h<this.custDivOption.length; h++){
                if(this.custDivOption[h].value == this.custDiv){
                    this.defaultCustDiv = this.custDivOption[h].text;
                }
            }
        }else{
             this.defaultCustDiv = '전체';
        }

        if(this.custDiv == 'SCD02'){ // 고객유형이 가망일 때는 계약에 대한 검색조건 초기화
            this.initForSCD02();
        }
    },
    selectFromAge: function(data){ // 자녀나이 시작 선택
       // console.log(data);
        this.fromAge = data;
        this.defaultFromAge = data;
    },
    selectToAge: function(data){ // 자녀나이 끝 선택
        //console.log(data);
        this.toAge = data;
        this.defaultToAge = data;
    },
    selectExpyYn: function(data){ // 상품만료여부 선택
        //console.log(data);
        this.concexpydyYn = data;

        for(var h=0; h<this.expyYnOption.length; h++){
            if(this.expyYnOption[h].value == this.concexpydyYn){
                this.defaultExpyYn = this.expyYnOption[h].text;
            }
        }
    },
    checkAllDgnsStat: function(){
        var selected = !this.dgnsStatAll;
        console.log("DetailSearch.vue checkAllDgnsStat this.selected",selected);
        this.dgnsStat1 = selected;
        this.dgnsStat2 = selected;
        this.dgnsStat3 = selected;
    },
    checkDgnsStat1: function(){
        var selected = !this.dgnsStat1;
        if(selected && this.dgnsStat2 && this.dgnsStat3){
            this.dgnsStatAll = true;
        }else{
            this.dgnsStatAll = false;
        }     
    },
    checkDgnsStat2: function(){
        var selected = !this.dgnsStat2;
        if(this.dgnsStat1 && selected && this.dgnsStat3){
            this.dgnsStatAll = true;
        }else{
            this.dgnsStatAll = false;
        }     
    },
    checkDgnsStat3: function(){
        var selected = !this.dgnsStat3;
        if(this.dgnsStat1 && this.dgnsStat2 && selected){
            this.dgnsStatAll = true;
        }else{
            this.dgnsStatAll = false;
        }     
    },
    popProdSearch: function() {
        var parent = {
            name: 'cstmr-prod-search-param',
            data: {
                selectedProdList: this.selectedProdList
            }
        };
        this.$store.commit("SET_UI_PARENT", parent);

      this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrList/proddSerach');
    },
    delPick: function(index){
        console.log('del : '+ this.selectedProdList[index].prdtnm);
        this.selectedProdList.splice(index, 1);
        if(this.selectedProdList.length == 0){
            this.prodIncludeYn = "";
        }
    },
    init: function(){ // 초기화
        this.custDiv = "";
        this.fromAge = "";
        this.toAge = "";
        this.dgnsStatAll = false;
        this.dgnsStat1 = false;
        this.dgnsStat2 = false;
        this.dgnsStat3 = false;
        this.KEDS = false;
        this.KEDI = false;
        this.ELT = false;
        this.ovrdY = false;
        this.ovrdN = false;
        this.concexpydyYn = "";
        this.prodIncludeYn = "";
        this.selectedProdList = [];
        
        this.defaultCustDiv = "전체";
        this.defaultExpyYn = "전체";
        this.defaultFromAge = "선택해주세요";
        this.defaultToAge = "선택해주세요";
    },
    initForSCD02: function(){ // 고객유형이 가망일 때는 계약에 대한 검색조건 초기화
        this.ovrdY = false;
        this.ovrdN = false;
        this.concexpydyYn = "";
        this.prodIncludeYn = "";
        this.selectedProdList = [];
        
        this.defaultExpyYn = "전체";
    },
    searchDetail: function(){ // 상세 검색조건 부모창으로 리턴.
      var child = {
        name: "cstmr-detail-search",
        data: this.params()
      };
      //console.log("DetailSearch.vue child",child);
      this.$utils.nativeIf.outbound.sendChildData(child);
    },
  },
  mounted: function() { //  인스턴스가 마운트 된 직후    
    var parent = this.$store.getters.parent;
        if(parent.name == 'my-cstmr-detal-search-param'){  // 부모창에서 받은 고객정보.
        console.log("DetailSearch.vue mounted parent.data", parent.data);
            this.custDiv = parent.data.custDiv;
            this.fromAge = parent.data.fromAge;
            this.toAge = parent.data.toAge;
            this.dgnsStat1 = parent.data.dgnsStat1;
            this.dgnsStat2 = parent.data.dgnsStat2;
            this.dgnsStat3 = parent.data.dgnsStat3;
            this.KEDS = parent.data.KEDS;
            this.KEDI = parent.data.KEDI;
            this.ELT = parent.data.ELT;
            this.ovrdY = parent.data.ovrdY;
            this.ovrdN = parent.data.ovrdN;
            this.concexpydyYn = parent.data.concexpydyYn;
            this.prodIncludeYn = parent.data.prodIncludeYn;
            this.selectedProdList = parent.data.selectedProdList;
            
            if("S" == parent.data.listTyp){
                this.custDivOption = [{text:'계약',value:'SCD01'}];
                this.custDiv = "SCD01";
            }
            
            // 넘어온 파라메터 초기화
            parent = {
                name: 'my-cstmr-detal-search-param',
                data: {
                    custDiv: "",     
                    fromAge: "",     
                    toAge: "",     
                    dgnsStat1: "",
                    dgnsStat2: "",
                    dgnsStat3: "",
                    KEDS: "",
                    KEDI: "",
                    ELT: "", 
                    ovrdY: "",      
                    ovrdN: "",   
                    concexpydyYn: "",     
                    prodIncludeYn: "",
                    selectedProdList: "",
                    listTyp: "",
                }
            };
            this.$store.commit("SET_UI_PARENT", parent);

            // 고객 구분이 넘어온 경우, 해당 구분자를 default로 선택되게 한다.
            if(this.custDiv){
                for(var h=0; h<this.custDivOption.length; h++){
                    if(this.custDivOption[h].value == this.custDiv){
                        this.defaultCustDiv = this.custDivOption[h].text;
                    }
                }
            }

            if(this.fromAge){
                this.defaultFromAge = this.fromAge;
            }
            if(this.toAge){
                this.defaultToAge = this.toAge;
            }

            if(this.concexpydyYn){
                for(var k=0; k<this.expyYnOption.length; k++){
                    if(this.expyYnOption[k].value == this.concexpydyYn){
                        this.defaultExpyYn = this.expyYnOption[k].text;
                    }
                }
            }
        }
  }	
};
</script>
